import { Injectable } from '@angular/core';
import { TagsCardComponent } from './tags-card.component';

@Injectable()
export class TagsCardService {
    activeUserDetailsCard: TagsCardComponent;

    show(card: TagsCardComponent): void {
        if (this.activeUserDetailsCard && this.activeUserDetailsCard !== card) {
            this.activeUserDetailsCard.hide = true;
        }

        this.activeUserDetailsCard = card;
        card.hide = false;
    }

    hide(card: TagsCardComponent): void {
        card.hide = true;

        if (this.activeUserDetailsCard === card) {
            this.activeUserDetailsCard = null;
        }
    }
}
